/**
 * "Already played" / last-result tracking is per browser tab (sessionStorage), but a tab
 * can see multiple different logins (e.g. testing several demo users in a row). Unscoped
 * keys leaked a previous user's "already played" state onto the next login in the same
 * tab — scope every key by that session's own token so switching users never collides.
 */
export function lsPlayedKey(adminToken) {
  return adminToken ? `ls_played_${adminToken}` : "ls_played";
}

export function lsLastResultIdKey(adminToken) {
  return adminToken ? `ls_last_result_id_${adminToken}` : "ls_last_result_id";
}
